import { createContext } from "react"

import { BottomSheetHeights } from "../../constants/bottomSheet"
import { NavigationOrigins } from "../../constants/navigationOrigins"

export const initialState = {
    currentBottomSheetHeight: BottomSheetHeights.SMALL,
    navigationOrigin: NavigationOrigins.NONE,
}

const initialDispatch = {}

export const ApplicationStateContext = createContext(initialState)
export const ApplicationDispatchContext = createContext(initialDispatch)
